import React from 'react';
import {withRouter} from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import {Nav, Row, Col, Button} from "react-bootstrap";
import logo from '../../../../asset/images/icon/logo-white.svg';
import style from './Menu.module.scss';
import { ADMIN_PANEL } from '../../../../environment/environment';

class Menu extends React.Component{
  constructor(props) {
    super(props);
  }

  redirect(to) {
    this.props.history.push(to);
  }

  render() {
    return (
        <React.Fragment>
          <Row className={'d-none d-md-flex align-items-center'}>
            <Col xs={3} className={`pl-2 justify-content-center ${style.third_menu}`}>
              <Button variant={'light'} className={`${style.advisor}`} onClick={()=> {
                window.location = ADMIN_PANEL;
              }}>ورود مشاور</Button>
              <Button variant={'secondary '} className={'ml-3'} onClick={() => {
                this.props.history.push(`/add-property`);
              }}>ثبت آگهی ملک</Button>
            </Col>

            <Col className={'p-0'}>
              <Nav className={'justify-content-center'}>
                <Nav.Link className={`${style.nav_items} ${style.right} text__white text__xsmall`} onClick={() => {
                  this.redirect('/contact-us')
                }}>تماس با ما</Nav.Link>
                <Nav.Link className={`${style.nav_items} ${style.right} text__white text__xsmall`} onClick={() => {
                  this.redirect('/about-us')
                }}>درباره ما</Nav.Link>
              </Nav>
            </Col>
            <Col xs={'auto'} className={`${style.logo}`}>
              <img src={logo} alt="Logo" width={'155'} height={'50'}/>
            </Col>
            <Col className={`p-0`}>
              <Nav className={'justify-content-center'}>
                <Nav.Link className={`${style.nav_items} ${style.left} text__white text__xsmall`} onClick={() => {
                  this.redirect('/advanced-search?transactionType=RENT')
                }}>رهن و اجاره</Nav.Link>
                <Nav.Link className={`${style.nav_items} ${style.left} text__white text__xsmall`} onClick={() => {
                  this.redirect('/advanced-search?transactionType=SELL')
                }}>خرید</Nav.Link>
              </Nav>
            </Col>

            <Col xs={3} className={style.empthy_menu} />
          </Row>
          <Navbar variant="dark" collapseOnSelect expand="md" className={`d-flex d-md-none ${style.nav_container}`}>
            <Navbar.Brand className={style.nav_brand}>
              <img src={logo} width={'155'} height={'50'} alt="Logo" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className={`${style.nvaBarIcon}`}/>
            <Navbar.Collapse id="responsive-navbar-nav"> 
              <Nav className={`${style.menuContainer}`}>
                <Nav.Link onClick={() => {
                  this.redirect('/advanced-search?transactionType=SELL')
                }}>خرید</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/advanced-search?transactionType=RENT')
                }}>رهن/اجاره</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/about-us')
                }}>درباره ما</Nav.Link>
                <Nav.Link onClick={() => {
                  this.redirect('/contact-us')
                }}>تماس با ما</Nav.Link>
                <Nav.Link onClick={() => {
                  this.props.history.push(`/add-property`);
                }}>ثبت آگهی ملک</Nav.Link>
                <Nav.Link onClick={() => {
                  window.location = ADMIN_PANEL;
                }}>ورود مشاور</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </React.Fragment>
    );
  }
}

export default (withRouter(Menu));
